/**
 * Product Recommendations - Quick Add to Cart
 * Handles variant selection and add to cart for recommended products
 * Based on cross-sell.js structure
 */

(function() {
  'use strict';

  class ProductRecommendations {
    constructor() {
      this.container = document.querySelector('[data-recommendations-container]');
      if (!this.container) return;

      this.init();
    }

    init() {
      // Handle color/variant selection via radio input
      this.container.addEventListener('change', (e) => {
        if (e.target.type === 'radio' && e.target.closest('[data-recommendations-option]')) {
          this.handleVariantChange(e.target);
        }
      });

      // Handle add to cart
      this.container.addEventListener('click', (e) => {
        const addBtn = e.target.closest('[data-add-to-cart]');
        if (addBtn && !addBtn.disabled) {
          this.handleAddToCart(addBtn);
        }
      });
    }

    handleVariantChange(radioInput) {
      const item = radioInput.closest('.m-product-rec-item');
      const variantId = radioInput.dataset.variantId;
      const productId = radioInput.dataset.productId;
      const imageUrl = radioInput.dataset.image;
      const price = radioInput.dataset.price;
      const available = radioInput.dataset.available === 'true';
      const productUrl = radioInput.dataset.productUrl;

      // Update image
      if (imageUrl) {
        const imgElement = item.querySelector('[data-rec-image]');
        if (imgElement) {
          imgElement.src = imageUrl;
        }
      }

      // Update product links
      if (productUrl) {
        const links = item.querySelectorAll('.m-product-rec-item__image a, .m-product-rec-item__title a');
        links.forEach(link => link.href = productUrl);
      }

      // Update add to cart button
      const addBtn = item.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.dataset.variantId = variantId;
        addBtn.dataset.productId = productId;
        addBtn.disabled = !available;

        // Update price
        if (price) {
          const priceElement = addBtn.querySelector('.m-product-rec-price');
          if (priceElement) {
            priceElement.textContent = this.formatMoney(parseInt(price));
          }
        }
      }
    }

    async handleAddToCart(btn) {
      const variantId = btn.dataset.variantId;
      const item = btn.closest('.m-product-rec-item');

      // Disable button temporarily
      btn.disabled = true;

      try {
        // Add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (response.ok) {
          // Check if SlideCart is being used (third-party app)
          if (typeof SLIDECART_UPDATE === 'function') {
            // Update cart content
            SLIDECART_UPDATE();

            // Open SlideCart
            setTimeout(() => {
              if (typeof SLIDECART_OPEN === 'function') {
                SLIDECART_OPEN();
              } else if (typeof SLIDECART_SHOW === 'function') {
                SLIDECART_SHOW();
              } else {
                // Fallback: simulate click on cart icon
                const cartIcon = document.querySelector('.m-cart-icon-bubble') ||
                                 document.querySelector('[data-cart-icon]') ||
                                 document.querySelector('.cart-icon');
                if (cartIcon) {
                  cartIcon.click();
                }
              }
            }, 300);
          } else {
            // Fallback to native Minimog cart drawer
            const cartDrawer = document.querySelector('m-cart-drawer') || document.getElementById('MinimogCartDrawer');

            if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
              cartDrawer.onCartDrawerUpdate();
              setTimeout(() => {
                cartDrawer.open();
              }, 200);
            }
          }

          // Re-enable button
          btn.disabled = false;
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        btn.disabled = false;
        alert('Unable to add product to cart. Please try again.');
      }
    }

    formatMoney(cents) {
      const amount = cents / 100;
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount).replace(',00', '');
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductRecommendations());
  } else {
    new ProductRecommendations();
  }
})();
